var _process$env$REACT_AP;
import Discord from "../icons/Discord";
import Github from "../icons/Github";
import Gitbook from "../icons/Gitbook";
import ManagerIcon from "../icons/ManagerIcon";
import BuilderIcon from "../icons/BuilderIcon";

// Note: Footer Navigation items
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const navigation = [
// note: the Manager and Builder icons are white... so they are not visible on the white background of the footer
{
  name: "Manager",
  href: "https://manager.gitcoin.co",
  testid: "support",
  icon: ManagerIcon
}, {
  name: "Builder",
  href: "https://builder.gitcoin.co",
  testid: "support",
  icon: BuilderIcon
}, {
  name: "Discord",
  href: "https://discord.gg/gitcoin",
  testid: "discord",
  icon: Discord
}, {
  name: "GitHub",
  href: "https://github.com/gitcoinco/grants-stack",
  testid: "github",
  icon: Github
}, {
  name: "Knowledge Base",
  href: "https://support.gitcoin.co/gitcoin-knowledge-base",
  testid: "knowledgebase",
  icon: Gitbook
}];
const COMMIT_HASH = (_process$env$REACT_AP = process.env.REACT_APP_GIT_SHA) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : "localhost";
export default function Footer() {
  return /*#__PURE__*/_jsxs("footer", {
    className: "py-3 px-4 sm:px-6 lg:px-20",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex flex-row-reverse justify-between py-6 overflow-hidden",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex justify-around space-x-4 md:order-1",
        children: navigation.map(item => /*#__PURE__*/_jsxs("a", {
          href: item.href,
          className: "text-gray-500 hover:text-gray-500",
          "data-testid": item.testid,
          children: [/*#__PURE__*/_jsx("span", {
            className: "sr-only hidden",
            children: item.name
          }), /*#__PURE__*/_jsx(item.icon, {})]
        }, item.name))
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "hidden",
      children: COMMIT_HASH
    })]
  });
}